var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-alert',{attrs:{"type":"error","border":"left"}},[_c('h3',[_vm._v("찾으시는 페이지("+_vm._s(_vm.$route.path)+")가 없습니다.")]),_c('span',{staticClass:"caption"},[_vm._v("404 page not found")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }